export const UPDATE_STEP = 'update_step';
export const UPDATE_VALUES = 'update_values'
export const QUESTION = 'question';
export const RESET = 'reset';
export const ACTIVATE_CONSUMER_ENROLLMENT = 'activate_consumer_form';